export default "__VITE_ASSET__561373ae__"